<h2
    mat-dialog-title
    class="tt-danger-background"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragBoundary=".cdk-overlay-container"
    cdkDragHandle
    style="color: white"
    ttTranslateWord="tt_cancel_orderlines_title"
></h2>
<mat-dialog-content style="padding-top: 2rem">
    <tt-select ttLabel="orderlinecancelcause_name" [(ttModel)]="cause" [ttData]="cancellationCauses" ttDataId="item_parms"></tt-select>
    <tt-textarea ttLabel="orderhead_cancellation_note" [(ttModel)]="note"></tt-textarea>
</mat-dialog-content>
<mat-dialog-actions align="end" style="gap: 1rem">
    <tt-button ttType="warning" ttText="tt_cancel_orderhead_abort" (ttClick)="dialogRef.close()"></tt-button>
    <tt-button ttType="danger" ttText="tt_cancel_orderhead_confirm" (ttClick)="cancelOrderlines()" [ttLoading]="processing"></tt-button>
</mat-dialog-actions>
